<dialog-confirm [title]="title ()" [text]="getInfo ()"></dialog-confirm>
<footer-close #footer (submit)="onSubmit ()"></footer-close>